import { Button, type ButtonProps } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import { track } from '../lib/analytics';

export interface CtaButtonProps extends Omit<ButtonProps, 'onClick'> {
  /** Destination: an in-app route, or an external/mailto URL. */
  to: string;
  /** Optional analytics event fired on click (consent-gated). */
  trackEventName?: string;
  trackProps?: Record<string, string>;
  /** Append the diagonal ↗ arrow (the brand CTA style). */
  withArrow?: boolean;
}

const ARROW = <ArrowForwardIcon transform="rotate(-45deg)" />;

/**
 * Primary marketing call-to-action. Renders a real crawlable anchor (so SEO
 * sees the link target) styled as a Chakra button, and fires a consent-gated
 * analytics event on click.
 */
export function CtaButton({ to, trackEventName, trackProps, withArrow, children, ...rest }: CtaButtonProps) {
  const external = /^(https?:|mailto:)/.test(to);
  const fire = () => {
    if (trackEventName) track(trackEventName, trackProps);
  };

  if (external) {
    return (
      <Button as="a" href={to} onClick={fire} rightIcon={withArrow ? ARROW : undefined} {...rest}>
        {children}
      </Button>
    );
  }
  return (
    <Button as={RouterLink} to={to} onClick={fire} rightIcon={withArrow ? ARROW : undefined} {...rest}>
      {children}
    </Button>
  );
}
